export const lowercaseParser = (value?: string) => {
  return value?.toLowerCase() || '';
};
